import React from 'react';
import Typography from "@material-ui/core/Typography";
import Helmet from "react-helmet";
import { useMutation } from 'react-apollo';
import { CREATE_TEMPLATE } from 'graphql/timeline-templates';
import Builder from './components/Builder'

const Crate = ({ history }) => {
  const [addTemplate] = useMutation(CREATE_TEMPLATE);

  const onSubmit = async (values) => {
      const { data }  = await addTemplate({
        variables: {
          data: {
            name: values.name,
            data: values.milestones
          }
        }
      });
      history.push(`/timeline-templates/${data.row.id}`);
  };

  return (
    <div>
      <Helmet title="Add Milestone Template" />
      <Typography gutterBottom variant="h6">Create Template</Typography>
      <Builder onSave={onSubmit} history={history} canEdit/>
    </div>
  )
}

export default Crate;
